import { render } from "./Grades.vue?vue&type=template&id=231da069&scoped=true"
import script from "./Grades.vue?vue&type=script&lang=js"
export * from "./Grades.vue?vue&type=script&lang=js"

import "./Grades.vue?vue&type=style&index=0&id=231da069&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-231da069"

export default script